import React from 'react'
import PropTypes from 'prop-types'
import PriceFormat from '../display-price/format-price'
import {Text, useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui'

const PricePerItem = ({currency, price}) => {
    const styles = useMultiStyleConfig('PricePerItem')
    return (
        <Text {...styles.textSize}>
            <PriceFormat price={price} currency={currency} />
        </Text>
    )
}

PricePerItem.propTypes = {
    currency: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired
}

export default PricePerItem
